
import { useEffect, useState } from 'react';
import globalData from '../common/globalData'
import * as Api from '../api/src'
const ConfigurationsApi = new Api.SystemConfigsApi();
const useInitData = () => {
    const getConfigurations = () => {
        ConfigurationsApi.apiSystemConfigsGet().then((res) => {
            if (res && res.data && res.data.Data) {
                globalData.Configurations = res?.data?.Data || null
            }
        });
    }
    useEffect(() => {
        getConfigurations();
    },[]);
}
export default useInitData;